<section class="seller-container">
  <div class="ids-mv-6 ids-p-3" *ngIf="!isLoadingData && !showError">
    <app-generic-end-form
      class="text"
      title="você finalizou o preenchimento dos formulários!"
      [text]="sellerPercentageData?.otherSellers?.length > 0 ? 'Agora é só aguardar os demais vendedores preencherem para o comprador seguir com o processo de financiamento' : 'Agora é só aguardar o comprador seguir com o processo de financiamento'"
      subtitle=""
      description=""
      linkWhatsapp=""
    >
    </app-generic-end-form>

    <div *ngIf="sellerPercentageData?.otherSellers?.length > 0">
      <app-other-sellers-percent [otherSellers]="sellerPercentageData?.otherSellers"></app-other-sellers-percent>
      <div class="ids-mb-4">
        <p class="ids-mb-4 ids-label -bold">demais vendedores</p>
      </div>

      <ol idsList>
        <ng-container *ngFor="let item of sellerPercentageData?.otherSellers">
          <li idsLi>
            <ids-icon idsLiIcon>{{ item.type === 'PERSON' ? 'user_base' : 'company_base' }}</ids-icon>
            <span idsLiLabel>{{ item.name }}</span>
            <span idsLiSupporting class="ids-tag" [ngClass]="item.isFilled ? '-success' : '-outline'">
              {{ item.isFilled ? 'preenchido' : 'pendente' }}</span>
          </li>
        </ng-container>
      </ol>
    </div>

    <div class="ids-row ids-mt-10">
      <div class="ids-col-4">
        <button idsMainButton full (click)="redirectToFormList()">
          ir para Crédito Imobiliário
        </button>
      </div>
    </div>
  </div>

  <app-error-screen *ngIf="showError && !isLoadingData" (onClickTryAgain)="reciverTryAgain()"
                    [errorCount]="errorCount"></app-error-screen>
</section>


<section aria-live="polite">
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="60vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
</section>

